export const SEARCH_KEYWORDS_REPORT_ID = 'search-keywords';
